import type { FaireProductEntity } from "../../entity_types/product";

export const p_ess8runjag: FaireProductEntity = {
  token: "p_ess8runjag",
  type: "product",
  name: "Tinted Tallow Lip Balm - Organic",
  brandToken: "b_wzhxy9syvt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a4b30addce91d2a8e087900f9c29e8b1dfb88e3e4f4cd28b9df42986514b0cfd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12107a5efbcbe8c518b3f27308e1e5944b9c55994eeaaa35622a5bb9eace5ded.png",
    "https://cdn.faire.com/fastly/d93f720b4eb568e2ee421b29c0fff0f683ec853ff0badd3416d6ff7ee12cf663.jpeg",
    "https://cdn.faire.com/fastly/336e5061097cc16e8e593ead9dd4a9a357010bcc76be5050dfac5ca51add4bd6.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Hydration meets beauty with our organic tallow-based tinted lip balms! Packed with skin loving nutrients, they soften, repair and protect - while giving your lips a beautiful shine.\n\nThese tinted lip balms with sheer color glide on effortlessly and give you a long lasting natural glow.\n\nClean, chemical-free beauty that loves you back!\n\n\n\nBeef tallow makeup? Yes please! 👏👏👏",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:33.583Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
